module.exports = __webpack_public_path__ + "img/tree-christmas.ef05a21c.svg";